import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import FinanceMuaBanHangService from "services/sale/FinanceMuaBanHangService";

export const GetAllFinanceMuaBanHang = createAsyncThunk(
  "financeMuaBanHang/GetAllFinanceMuaBanHang",
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceMuaBanHangService.GetAllFinanceMuaBanHang(
        data
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const GetFinanceMuaBanHangId = createAsyncThunk(
  "financeMuaBanHang/GetFinanceMuaBanHangId",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await FinanceMuaBanHangService.GetFinanceMuaBanHangId(
        payload
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const UpsertFinanceMuaBanHang = createAsyncThunk(
  "financeMuaBanHang/UpsertFinanceMuaBanHang",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await FinanceMuaBanHangService.UpsertFinanceMuaBanHang(
        payload
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DeleteFinanceMuaBanHang = createAsyncThunk(
  "financeMuaBanHang/DeleteFinanceMuaBanHang",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await FinanceMuaBanHangService.DeleteFinanceMuaBanHang(
        id
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
///Chi tiết

export const GetFinanceDSChiTietMuaBanHang = createAsyncThunk(
  "financeMuaBanHang/GetFinanceDSChiTietMuaBanHang",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await FinanceMuaBanHangService.GetFinanceDSChiTietMuaBanHang(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpsertFinanceMuaBanHangChiTiet = createAsyncThunk(
  "financeMuaBanHang/UpsertFinanceMuaBanHangChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      console.log("vao day 1122");
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await FinanceMuaBanHangService.UpsertFinanceMuaBanHangChiTiet(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const DeleteFinanceMuaBanHangChiTiet = createAsyncThunk(
  "financeMuaBanHang/DeleteFinanceMuaBanHangChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response =
        await FinanceMuaBanHangService.DeleteFinanceMuaBanHangChiTiet(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
const initialState = {
  loading: false,
  FinanceMuaBanHangList: [],
  FinanceMuaBanHangDetail: {},
  FinanceMuaBanHangChiTietList: [],
};

export const financeMuaBanHangSlice = createSlice({
  name: "nhapxuat",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setHisInfo: (state, action) => {
      state.hisInfoList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //GetFinanceDSChiTietMuaBanHang
      .addCase(GetFinanceDSChiTietMuaBanHang.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetFinanceDSChiTietMuaBanHang.fulfilled, (state, action) => {
        state.loading = false;
        state.FinanceMuaBanHangChiTietList = action.payload;
      })
      .addCase(GetFinanceDSChiTietMuaBanHang.rejected, (state, action) => {
        state.loading = false;
      })
      //GetAllFinanceMuaBanHang
      .addCase(GetFinanceMuaBanHangId.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetFinanceMuaBanHangId.fulfilled, (state, action) => {
        state.loading = false;
        state.FinanceMuaBanHangDetail = action.payload;
      })
      .addCase(GetFinanceMuaBanHangId.rejected, (state, action) => {
        state.loading = false;
      })
      //GetAllFinanceMuaBanHang
      .addCase(GetAllFinanceMuaBanHang.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllFinanceMuaBanHang.fulfilled, (state, action) => {
        state.loading = false;
        state.FinanceMuaBanHangList = action.payload;
      })
      .addCase(GetAllFinanceMuaBanHang.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setHisInfo } = financeMuaBanHangSlice.actions;

export default financeMuaBanHangSlice.reducer;
